import { SIStates } from './SIStates';

export const Contexts = () => {
    return {
        si_state: SIStates(),
    }
}